import type { ProLayoutProps } from '@ant-design/pro-components';

/**
 * @name
 */
const Settings: ProLayoutProps & {
  logo?: string;
  locale?: boolean;
} = {
  navTheme: 'light',
  colorPrimary: '#1677ff',
  layout: 'mix',
  contentWidth: 'Fluid',
  fixedHeader: true,
  fixSiderbar: true,
  colorWeak: false,
  splitMenus: true,
  title: 'ERP',
  logo: '/logo.svg',
  iconfontUrl: '',
  /** 关闭右上角语言切换 */
  locale: false,
  menu: {},
  token: {},
};

export default Settings;
